import { Store } from "@tanstack/react-store";
import { sessionStoreSlice, type SessionStoreSlice } from "./sessionStoreSlice";
import {
    taxSubmissionsStoreSlice,
    type TaxSubmissionFilterSearch,
} from "./taxSubmissionSearchFiltersStoreSlice";

export interface GovernmentAgencyHubAppStoreSlice<T> {
    defaultValues: T;
    resetValues: () => void;
    updateValues: (newValues: Partial<T>) => void;
}

export interface GovernmentAgencyHubAppStore {
    session: SessionStoreSlice;
    taxSubmissionsSearchFilters: TaxSubmissionFilterSearch;
}

const defaultStoreValues: GovernmentAgencyHubAppStore = {
    session: sessionStoreSlice.defaultValues,
    taxSubmissionsSearchFilters: taxSubmissionsStoreSlice.defaultValues,
};

export const store = new Store<GovernmentAgencyHubAppStore>(defaultStoreValues);
